<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-40">
    <!--      volver button for mobile -->
    <section class="ml-[31px] block sm:hidden">
      <button (click)="goHome()" class="mb-[13px] mt-[21px]">
        <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
      </button>
    </section>

    <section
      class="border-t-opacity-10 sm:border-b-opacity-10 border-t-[1.8px] border-t-beige bg-blanco bg-opacity-10 sm:border-b-[1.8px] sm:border-b-beige sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]">
      <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
        <div class="mx-[36px] sm:mx-[120px]">
          <!-- top components -->
          <!--      volver button-->
          <section class="hidden sm:block">
            <button
              (click)="goHome()"
              class="mb-[14px] mt-[15px] flex items-center transition duration-100 hover:scale-110">
              <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
              <span class="ml-[6px] font-['Roboto'] text-base font-normal text-cafe">{{
                'buttons.goHome' | transloco
              }}</span>
            </button>
          </section>
        </div>
      </div>
    </section>
    <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
      <div class="mx-[36px] flex min-h-[600px] flex-col pb-[52px] pt-[25px] sm:mx-[120px]">
        <ln-artisans-designers-created-and-sold-products></ln-artisans-designers-created-and-sold-products>
      </div>
      <div class="flex items-center border-b-[2px] border-b-verde opacity-40 sm:mx-[68px]"></div>
    </div>
  </section>
</ln-ln-pages-armor>
